// Lavabos Cosentino : sélection de la variante Shopify à partir des choix du client.
// Le prix vient toujours de variant.price ; aucun montant n'est calculé dans le navigateur.
export const WASHBASIN_SIDES = [
  { value: 'both', label: 'Avant et deux côtés' },
  { value: 'left', label: 'Avant et côté gauche' },
  { value: 'right', label: 'Avant et côté droit' },
  { value: 'front', label: 'Avant uniquement' },
];

export function selectWashbasinVariant(config, variants, state) {
  if (!config || !Array.isArray(config.basins) || !Array.isArray(variants)) return { valid: false, reason: 'configuration' };
  const basin = config.basins.find((b) => b.ref === state.basin) ?? (config.basins.length === 1 ? config.basins[0] : null);
  if (!basin) return { valid: false, reason: 'basin' };
  const skirt = basin.skirts.find((s) => s.code === state.skirt);
  if (!skirt) return { valid: false, reason: 'skirt' };
  const finish = config.finishes.length === 1 ? config.finishes[0] : state.finish;
  if (!config.finishes.includes(finish)) return { valid: false, reason: 'finish' };
  const tap = config.tapDrill ? state.tapDrill !== false : false;
  const sides = skirt.hasSkirt ? (WASHBASIN_SIDES.find((s) => s.value === state.sides) ?? WASHBASIN_SIDES[0]) : null;
  if (state.length === '' || state.width === '' || state.length == null || state.width == null) return { valid: false, reason: 'missing', basin, skirt };
  const l = Number(state.length), w = Number(state.width);
  if (!Number.isSafeInteger(l) || !Number.isSafeInteger(w)) return { valid: false, reason: 'integer', basin, skirt };
  const minW = tap && skirt.widthMm.minWithTap ? skirt.widthMm.minWithTap : skirt.widthMm.min;
  if (l < skirt.lengthMm[0] || l > skirt.lengthMm[1]) return { valid: false, reason: 'length', basin, skirt, minW };
  if (w < minW || w > skirt.widthMm.max) return { valid: false, reason: 'width', basin, skirt, minW };
  const segments = skirt.segments.filter((g) => l >= g.min && l <= g.max);
  if (segments.length !== 1) return { valid: false, reason: 'tariff', basin, skirt };
  const wanted = { Vasque: basin.label, Finition: finish, 'Format tarifaire': segments[0].value };
  const expected = config.optionNames.map((n) => wanted[n]);
  const matches = variants.filter((v) => Array.isArray(v.options) && v.options.length === expected.length && v.options.every((o, i) => o === expected[i]));
  const variant = matches.length === 1 ? matches[0] : null;
  if (!variant || !Number.isSafeInteger(Number(variant.price)) || Number(variant.price) <= 0) return { valid: false, reason: 'unavailable', basin, skirt };
  const properties = {
    'Longueur exacte (mm)': String(l),
    'Largeur exacte (mm)': String(w),
    'Bordure': skirt.label,
    ...(sides ? { 'Retombée sur': sides.label } : {}),
    ...(config.tapDrill ? { 'Perçage robinet': tap ? 'Oui, un perçage' : 'Non, robinet mural' } : {}),
    'Modèle': config.model,
    'Matière': config.material,
    'Coloris': config.color,
  };
  return { valid: true, purchasable: config.purchaseReady === true && variant.available === true, variant, basin, skirt, finish, properties };
}

const PROPERTY_NAMES = ['Longueur exacte (mm)', 'Largeur exacte (mm)', 'Bordure', 'Retombée sur', 'Perçage robinet', 'Modèle', 'Matière', 'Coloris'];

export function bindWashbasinConfigurator(root) {
  if (root.dataset.bound) { root.washbasinRefresh?.(); return; }
  const config = JSON.parse(root.querySelector('[data-config]').textContent);
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const form = document.getElementById(root.dataset.formId);
  const section = root.closest('.shopify-section');
  if (!form || !section) return;
  root.dataset.bound = 'true';
  const q = (s) => root.querySelector(s);
  const length = q('[data-length]'), width = q('[data-width]'), message = q('[data-message]'), range = q('[data-range]');
  const preview = section.querySelector('[data-washbasin-price]');
  const submitButtons = [...form.querySelectorAll('[type="submit"]')];
  const hidden = Object.fromEntries(PROPERTY_NAMES.map((name) => {
    const input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${name}]`; form.append(input); return [name, input];
  }));
  const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const checked = (name) => root.querySelector(`input[name="${name}-${root.dataset.uid}"]:checked`)?.value;
  let selection;
  const renderSkirts = () => {
    // Les bordures dépendent de la vasque choisie : on n'affiche que celles de la vasque.
    const basin = checked('basin') ?? config.basins[0].ref;
    const previous = root.querySelector(`input[name="skirt-${root.dataset.uid}"]:checked`)?.value;
    let current = null;
    root.querySelectorAll('[data-skirt-for]').forEach((el) => {
      el.hidden = el.dataset.skirtFor !== basin;
      el.querySelectorAll('input').forEach((i) => { i.disabled = el.hidden; });
      if (!el.hidden) current = [...el.querySelectorAll('input')].find((i) => i.value === previous) ?? el.querySelector('input');
    });
    if (current && !current.checked) current.checked = true;
    const sidesBox = q('[data-sides]'); if (sidesBox) sidesBox.hidden = current?.dataset.hasSkirt !== 'true';
    return { basin, skirt: current?.value };
  };
  const update = () => {
    const { basin, skirt } = renderSkirts();
    selection = selectWashbasinVariant(config, variants, { basin, skirt, finish: checked('finish'), sides: checked('sides'), tapDrill: checked('tap') !== 'no', length: length.value, width: width.value });
    const sk = selection.skirt ?? config.basins.find((b) => b.ref === basin)?.skirts.find((s) => s.code === skirt);
    if (sk && range) {
      const tap = config.tapDrill && checked('tap') !== 'no';
      const minW = tap && sk.widthMm.minWithTap ? sk.widthMm.minWithTap : sk.widthMm.min;
      const n = (v) => Number(v).toLocaleString('fr-FR');
      range.textContent = `Longueur de ${n(sk.lengthMm[0])} à ${n(sk.lengthMm[1])} mm · largeur de ${n(minW)} à ${n(sk.widthMm.max)} mm.`;
      length.min = sk.lengthMm[0]; length.max = sk.lengthMm[1]; width.min = minW; width.max = sk.widthMm.max;
    }
    const ready = selection.valid && selection.purchasable;
    submitButtons.forEach((b) => {
      b.disabled = !ready;
      if (!ready) b.setAttribute('aria-disabled', 'true');
      else if (!b.classList.contains('btn--loading')) b.removeAttribute('aria-disabled');
    });
    PROPERTY_NAMES.forEach((name) => { hidden[name].value = selection.valid ? (selection.properties[name] ?? '') : ''; hidden[name].disabled = !(selection.valid && selection.properties[name]); });
    const idInput = form.querySelector('[name="id"]');
    if (idInput) { idInput.disabled = !ready; idInput.value = selection.valid ? selection.variant.id : ''; }
    if (preview) preview.textContent = selection.valid ? `${money(Number(selection.variant.price))} TTC` : `À partir de ${money(Number(root.dataset.priceMin))} TTC`;
    const msg = {
      missing: '', integer: 'Saisissez des mesures entières en millimètres.',
      length: 'Cette longueur n’est pas proposée en achat direct pour cette vasque et cette bordure. Demandez un devis.',
      width: 'Cette largeur n’est pas proposée en achat direct. Demandez un devis.',
    }[selection.reason];
    message.textContent = selection.valid ? `Votre plan : ${length.value} × ${width.value} mm · ${selection.skirt.label.toLowerCase()}${selection.finish && config.finishes.length > 1 ? ` · finition ${selection.finish.toLowerCase()}` : ''}.` : (msg ?? 'Cette configuration n’est pas proposée en achat direct. Demandez un devis.');
    length.setAttribute('aria-invalid', String(['length', 'integer', 'tariff'].includes(selection.reason)));
    width.setAttribute('aria-invalid', String(['width', 'integer'].includes(selection.reason)));
  };
  root.washbasinRefresh = update;
  root.addEventListener('input', update);
  root.addEventListener('change', update);
  form.addEventListener('submit', (event) => { update(); if (!selection?.valid || !selection.purchasable) { event.preventDefault(); event.stopImmediatePropagation(); length.focus(); } }, true);
  root.addEventListener('touchend', (event) => { if (event.target.matches('input,select,label')) event.stopPropagation(); });
  update();
}

if (typeof document !== 'undefined') {
  const init = () => document.querySelectorAll('[data-washbasin-configurator]').forEach(bindWashbasinConfigurator);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
}
